import React, { useEffect, useState, useCallback } from "react";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { LuCheck, LuClock, LuListTodo } from "react-icons/lu";
import { getMyTasks, completeTask } from "../../Services/engagementService";

const TABS = [
  { key: "overdue", label: "Overdue" },
  { key: "today", label: "Today" },
  { key: "upcoming", label: "Upcoming" },
];

const MyTasks = () => {
  const [scope, setScope] = useState("overdue");
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const load = useCallback(() => {
    setLoading(true);
    getMyTasks({ status: "open", scope })
      .then((d) => setTasks(d || []))
      .catch(() => setTasks([]))
      .finally(() => setLoading(false));
  }, [scope]);

  useEffect(() => {
    load();
  }, [load]);

  const done = async (id) => {
    await completeTask(id).catch(() => {});
    setTasks((prev) => prev.filter((t) => t.id !== id));
  };

  return (
    <div className="page-container p-6">
      <div className="flex items-center gap-2 mb-6">
        <LuListTodo className="text-[#425F80]" size={26} />
        <h1 className="text-2xl font-bold text-gray-800">My Follow-ups</h1>
      </div>

      <div className="flex gap-2 mb-5">
        {TABS.map((t) => (
          <button
            key={t.key}
            onClick={() => setScope(t.key)}
            className={`px-4 py-2 rounded-lg text-sm font-medium ${
              scope === t.key ? "bg-[#425F80] text-white" : "bg-gray-100 text-gray-600"
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {loading ? (
        <p className="text-gray-400">Loading…</p>
      ) : tasks.length === 0 ? (
        <div className="text-center text-gray-400 py-16">
          <LuClock size={40} className="mx-auto mb-3 opacity-40" />
          <p>No {scope} follow-ups. You're on top of it.</p>
        </div>
      ) : (
        <div className="space-y-2 max-w-2xl">
          {tasks.map((t) => {
            const overdue = new Date(t.due_at) < new Date();
            return (
              <div
                key={t.id}
                className="flex items-center justify-between bg-white rounded-xl border border-gray-100 px-4 py-3"
              >
                <button
                  onClick={() => navigate(`/leads/details/${t.lead_id}`)}
                  className="text-left"
                >
                  <p className="font-medium text-gray-800">{t.title}</p>
                  <p className={`text-xs ${overdue ? "text-red-500" : "text-gray-400"}`}>
                    {t.type} · {moment(t.due_at).format("DD MMM YYYY, h:mm A")}
                    {overdue ? " · overdue" : ""}
                  </p>
                </button>
                <button
                  onClick={() => done(t.id)}
                  className="flex items-center gap-1 text-xs bg-green-50 text-green-700 border border-green-200 rounded-lg px-3 py-1.5"
                >
                  <LuCheck size={14} /> Done
                </button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MyTasks;
